import { getPageDraftVersionId } from "@/queries/page";
import { languageKeys } from "@op/puck-types";
import { createFileRoute, redirect } from "@tanstack/react-router";
import z from "zod";

const paramSchema = z.object({
  organizationSlug: z.string(),
  projectSlug: z.string(),
  languageKey: z.enum(languageKeys),
  topicSlug: z.string(),
  pageSlug: z.string(),
});

export const Route = createFileRoute(
  "/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/"
)({
  params: paramSchema,
  beforeLoad: async ({
    params: { organizationSlug, projectSlug, languageKey, topicSlug, pageSlug },
  }) => {
    const { draftVersionId } = await getPageDraftVersionId(
      organizationSlug,
      projectSlug,
      languageKey,
      topicSlug,
      pageSlug
    );
    throw redirect({
      to: "/app/$organizationSlug/$projectSlug/$languageKey/$topicSlug/$pageSlug/$versionId",
      params: {
        organizationSlug,
        projectSlug,
        languageKey,
        topicSlug,
        pageSlug,
        versionId: draftVersionId,
      },
      replace: true,
      statusCode: 307,
    });
  },
  component: RouteComponent,
});

function RouteComponent() {
  return null;
}
